import underscore from 'underscore';

const _ = (window._sv = underscore);

export default _;
